import debounce from "lodash/debounce";
import { useEffect, useState } from "react";

/**
 * Hook that tracks whether the current viewport width is below a specified breakpoint
 * @param breakpoint The width in pixels to compare against
 * @returns boolean indicating if the current viewport is smaller than the breakpoint
 */
export const useIsSmallerThanBreakpoint = (breakpoint: number) => {
  const [isSmallerThan, setIsSmallerThan] = useState<boolean>(false);

  useEffect(() => {
    // Handle resizing the window
    const handleWindowResize = debounce(
      () => setIsSmallerThan(window.innerWidth < breakpoint),
      100,
    );

    // Initial check
    handleWindowResize();

    // Add resize listener
    window.addEventListener("resize", handleWindowResize);

    // Cleanup
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, [breakpoint]);

  return isSmallerThan;
};
